import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Heart, HandHeart, Sparkle } from '@phosphor-icons/react';

const Charity = () => {
  const [causes, setCauses] = useState([]);
  const [donations, setDonations] = useState([]);
  const [total, setTotal] = useState(0);

  const load = async () => {
    const [c, r] = await Promise.all([api.get('/charities'), api.get('/charities/recent')]);
    setCauses(c.data.charities);
    setTotal(c.data.total_energy_donated);
    setDonations(r.data.donations);
  };
  useEffect(() => { load(); }, []);

  const donate = async (cause_id) => {
    try {
      await api.post('/charities/donate', { cause_id });
      toast.success('Energy converted to impact.');
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'cannot donate'); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-10 pb-24">
      <div className="text-center mb-10">
        <HandHeart size={36} className="text-bx-cyan mx-auto" weight="duotone" />
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Impact</h1>
        <p className="text-white/60 mt-1">Turn momentum into change. Every donation is hash-chained for transparency.</p>
      </div>

      <div className="grad-border p-6 text-center mb-8">
        <div className="text-[10px] uppercase tracking-widest text-white/65">Total energy donated</div>
        <div className="font-display text-5xl font-black shimmer-text mt-1">{total.toLocaleString()}⚡</div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {causes.map((c) => (
          <div key={c.id} data-testid={`charity-${c.id}`} className="glass rounded-2xl p-5 flex flex-col">
            <div className="chip text-bx-cyan border-bx-cyan/30">{c.tag}</div>
            <h3 className="font-display text-lg font-bold mt-3">{c.name}</h3>
            <p className="text-white/60 text-sm mt-1 flex-1">{c.blurb}</p>
            <div className="mt-4 flex items-center justify-between">
              <div className="text-sm">
                <div className="text-bx-volt font-black font-display text-xl">{c.total_pool || 0}⚡</div>
                <div className="text-[10px] uppercase tracking-widest text-white/60">collected · {c.donations || 0} givers</div>
              </div>
              <button data-testid={`donate-${c.id}`} onClick={() => donate(c.id)} className="btn-volt px-4 py-2 rounded-full text-xs flex items-center gap-1">
                <Heart size={12} weight="fill" /> Donate 10⚡
              </button>
            </div>
          </div>
        ))}
      </div>

      <h2 className="font-display text-2xl font-bold mt-12 mb-4">Live impact stream</h2>
      <div className="space-y-2">
        {donations.length === 0 && <div className="text-white/60 text-sm">No donations yet. Be the first.</div>}
        {donations.map((d) => (
          <div key={d.id} className="glass rounded-xl p-3 flex items-center gap-3 text-sm">
            <Sparkle size={14} className="text-bx-volt" weight="fill" />
            <span className="text-bx-cyan font-bold">@{d.username}</span>
            <span className="text-white/60">donated</span>
            <span className="text-bx-volt font-bold">{d.energy}⚡</span>
            <span className="text-white/60">to</span>
            <span className="text-bx-magenta font-bold">{d.cause_name}</span>
            <span className="ml-auto text-[10px] uppercase tracking-widest text-white/55">
              {new Date(d.ts).toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Charity;
